export const PRIMARY_COLOR = '#4FD1C5';
export const RED_COLOR = '#E53E3E';
export const BG_LOADING = '#F7FAFC';
export const BG_PAGE = '#F7FAFC';
export const BG_CHILDREN = '#FFF';
export const BG_CANCEL = '#EDF2F7';

// Text colors
export const TEXT_PRIMARY = '#2D3748';
export const TEXT_SECONDARY = '#A0AEC0';
export const TEXT_GRAY_400 = '#A0AEC0';
export const TEXT_GRAY_500 = '#718096';
export const TEXT_GRAY_600 = '#4A5568';
export const TEXT_GRAY_700 = '#6A6A6A';

// Border colors
export const BORDER_GRAY_200 = '#E2E8F0';

export const PAGE_SIZE = 10;
export const PAGE_SIZE_FULL = 100;
export const IS_TRANSLATE = true;

export const fileAccept = {
  image: ['.png', '.jpg', '.jpeg', '.gif'],
  texture: ['.png'],
  //   textureReg: /\.(jpg|jpeg|png)$/i,
  textureReg: /\.(png)$/i,
  colorReg: /\.(png)$/i,
  zipReg: /\.(zip)$/i,
  model: ['.glb'],
  color: ['.png', '.zip'],
  zip: ['.zip'],
  materialTexture: ['.zip', '.png'],
};

export const mimeTypes = {
  png: 'image/png',
  zip: 'application/zip',
};

export const INVALID_TOKEN_MSG = 'Unauthorized';
export const DEBOUNCE_TIME = 1500;
export const pipingParts = ['piping', 'パイピング'];

export const fileSizes = {
  baseImage: {
    size: 10 * 1024 * 1024, // 10mb
    name: '10MB',
  },
  texture: {
    size: 20 * 1024 * 1024, // 20mb
    name: '20MB',
  },
  glb: {
    size: 30 * 1024 * 1024, // 30mb
    name: '30MB',
  },
  file: {
    size: 30 * 1024 * 1024, // 30mb
    name: '30MB',
  },
};

export const IS_CHECK_FILE_SIZE = false;

export const FILE_SIZE_LIMITS = {
  HTML: 5 * 1024 * 1024, // 5MB
  CSS: 5 * 1024 * 1024, // 5MB
  JS: 5 * 1024 * 1024, // 5MB
  ZIP: 10 * 1024 * 1024, // 10MB
  DEFAULT: 5 * 1024 * 1024, // 5MB
};

export const FILE_TYPE_CONFIG = {
  html: {
    name: 'HTML',
    extension: 'html',
    maxSize: FILE_SIZE_LIMITS.HTML,
    uploadTextKey: 'plan.fileUploadTexts.htmlFileText',
  },
  css: {
    name: 'CSS',
    extension: 'css',
    maxSize: FILE_SIZE_LIMITS.CSS,
    uploadTextKey: 'plan.fileUploadTexts.cssFileText',
  },
  js: {
    name: 'JS',
    extension: 'js',
    maxSize: FILE_SIZE_LIMITS.JS,
    uploadTextKey: 'plan.fileUploadTexts.jsFileText',
  },
  zip: {
    name: 'ZIP',
    extension: 'zip',
    maxSize: FILE_SIZE_LIMITS.ZIP,
    uploadTextKey: 'plan.fileUploadTexts.zipFileText',
  },
};

export const XSS_PATTERNS = [
  /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
  /<iframe\b[^>]*>/gi,
  /<object\b[^>]*>/gi,
  /<embed\b[^>]*>/gi,
  /<form\b[^>]*>/gi,
  /on\w+\s*=/gi,
  /javascript:/gi,
  /vbscript:/gi,
  /data:(?!image\/)/gi,
  /<link\b[^>]*>/gi,
  /<meta\b[^>]*>/gi,
  /<base\b[^>]*>/gi,
];

export const CSS_DANGEROUS_PATTERNS = [
  /expression\s*\(/gi,
  /javascript:/gi,
  /vbscript:/gi,
  // /@import/gi,
  /behavior\s*:/gi,
  /-moz-binding/gi,
  /url\s*\(\s*["']?javascript:/gi,
];

export const JS_DANGEROUS_PATTERNS = [
  /eval\s*\(/gi,
  /Function\s*\(/gi,
  /setTimeout\s*\(\s*["']/gi,
  /setInterval\s*\(\s*["']/gi,
  /document\.write/gi,
  /innerHTML/gi,
  /outerHTML/gi,
  /insertAdjacentHTML/gi,
];

export const PASSWORD_HALF_WIDTH_PATTERN = /^[a-zA-Z0-9@#$%!_.-]+$/;
export const SCROLL_NEAR_BOTTOM_THRESHOLD = 50; // 50px